import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import axios from 'axios'

import { isRequired, isValidEmail } from 'utils/formValidations'

import { Form, FormInput } from 'components/forms'
import Button from 'components/virtual/buttons/Button'
import Text from 'components/texts/Text'

import ErrorBox from './ErrorBox'

const useStyles = makeStyles({
  input: {
    marginBottom: 18,
  },
  submitButton: {
    marginBottom: 24,
  },
  subtitle: {
    marginBottom: 38,
  },
  title: {
    marginBottom: 16,
  },
})

function ForgotPasswordForm() {
  const classes = useStyles()

  const [error, setError] = useState('')
  const [formValid, setFormValid] = useState(false)
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const exposeValues = form => {
    setFormValid(form.valid)
  }

  const disabled = loading || !formValid

  const resetPassword = async ({ email }) => {
    setLoading(true)
    setError('')
    try {
      await axios.post('/send-reset-link', {
        email,
      })
      setSent(true)
      setLoading(false)
    } catch (err) {
      setError('There was an error resetting your password. Please contact support@dojomojo.com')
      setLoading(false)
    }
  }

  return (
    <>
      <div className={classes.title}>
        <Text size={34}>Forgot password</Text>
      </div>
      {sent ? (
        <div className={classes.subtitle}>
          <Text charcoalLight size={16}>
            You will receive an email shortly with instructions to reset your password. If you do
            not see the email, please check your spam folder.
          </Text>
        </div>
      ) : (
        <>
          <div className={classes.subtitle}>
            <Text charcoalLight size={16}>
              Enter your email address below and we&apos;ll send you reset instructions.
            </Text>
          </div>
          {!!error && <ErrorBox value={error} />}
          <Form
            exposeValues={exposeValues}
            initialValues={{ email: '' }}
            onSubmit={resetPassword}
            withSubmit="resetPassword"
          >
            <div className={classes.input}>
              <FormInput
                compact
                disableErrorText
                fullWidth
                label="Work Email"
                name="email"
                theme="virtual"
                type="text"
                useComponentError
                validations={[isRequired, isValidEmail]}
              />
            </div>
          </Form>
          <div className={classes.submitButton}>
            <Button
              color="primary"
              disabled={disabled}
              fullWidth
              id="resetPassword"
              label="Reset Password"
              size="medium"
              type="contained"
            />
          </div>
        </>
      )}
    </>
  )
}

export default React.memo(ForgotPasswordForm)
